import { Helmet } from 'react-helmet-async';
import { useStoreInfo } from '@/lib/store';
import { ClearCacheButton } from '@/components/ui/clear-cache-button';

export function SettingsPage() {
  const { storeInfo } = useStoreInfo();
  const pageTitle = `Settings${storeInfo?.site_name ? ` - ${storeInfo.site_name}` : ''}`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Manage your app preferences" />
      </Helmet>

      <div className="min-h-screen bg-gray-100 py-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">Settings</h1>

          <div className="space-y-6">
            {/* Cache Management */}
            <ClearCacheButton variant="full" />

            {/* Other Settings */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
              <div className="divide-y divide-gray-200">
                {/* App Info */}
                <div className="p-6">
                  <div>
                    <h2 className="text-lg font-medium text-gray-900">App Information</h2>
                    <p className="text-sm text-gray-500 mt-1">
                      Version 2.0.0
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}